import {
  TICKETS_RECEIVE_FAIL,
  TICKETS_RECEIVE_SUCCESS,
  TICKETS_RECEIVE_REQUEST,
  TICKET_RECEIVE_FAIL,
  TICKET_RECEIVE_SUCCESS,
  TICKET_RECEIVE_REQUEST,
  TICKET_UPDATE_FAIL,
  TICKET_UPDATE_SUCCESS,
  TICKET_UPDATE_REQUEST,
  TICKET_CREATE_FAIL,
  TICKET_CREATE_SUCCESS,
  TICKET_CREATE_REQUEST,
  GET_CHAT_REQUEST,
  GET_CHAT_SUCCESS,
  GET_CHAT_FAIL,
  POST_CHAT_REQUEST,
  POST_CHAT_SUCCESS,
  POST_CHAT_FAIL,
  ADDTO_CHAT_SUCCESS,
  SEND_TRANSCRIPT_REQUEST,
  SEND_TRANSCRIPT_SUCCESS,
  SEND_TRANSCRIPT_FAIL,
} from "./supportType";

function updateOpenTicketsCount(state, updatedTicket) {
  if (!Number.isFinite(state.openTicketsCount) || !Array.isArray(state.tickets)) {
    return state.openTicketsCount;
  }

  const previousTicket = state.tickets.find((ticket) => ticket._id === updatedTicket?._id);
  if (!previousTicket || previousTicket.status === updatedTicket?.status) {
    return state.openTicketsCount;
  }
  if (previousTicket.status === "CLOSED" && updatedTicket?.status !== "CLOSED") {
    return state.openTicketsCount + 1;
  }
  if (previousTicket.status !== "CLOSED" && updatedTicket?.status === "CLOSED") {
    return Math.max(0, state.openTicketsCount - 1);
  }
  return state.openTicketsCount;
}

export const supportReducer = (state = { chat: [] }, action) => {
  switch (action.type) {
    case TICKETS_RECEIVE_REQUEST:
      return { ...state, loading: true, error: null };

    case TICKETS_RECEIVE_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload.tickets,
        total: action.payload.totalTicketsCount,
        openTicketsCount: action.payload.openTicketsCount,
        error: null,
      };

    case TICKETS_RECEIVE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Single get
    case TICKET_RECEIVE_REQUEST:
      return { ...state, loading: true };

    case TICKET_RECEIVE_SUCCESS:
      return { ...state, loading: false, singleTicket: action.payload };

    case TICKET_RECEIVE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Single Update
    case TICKET_UPDATE_REQUEST:
      return { ...state, updatingTicketId: action.payload, updateError: null };

    case TICKET_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        updatingTicketId: null,
        updateError: null,
        singleTicket: action.payload,
        openTicketsCount: updateOpenTicketsCount(state, action.payload),
        tickets: Array.isArray(state.tickets)
          ? state.tickets.map((ticket) =>
              ticket._id === action.payload?._id ? action.payload : ticket
            )
          : state.tickets,
      };

    case TICKET_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        updatingTicketId: null,
        updateError: action.payload,
      };

    // create ticket
    case TICKET_CREATE_REQUEST:
      return { ...state, loading: true };

    case TICKET_CREATE_SUCCESS:
      return { ...state, loading: false, singleTicket: action.payload };

    case TICKET_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // get chat
    case GET_CHAT_REQUEST:
      return { ...state };

    case GET_CHAT_SUCCESS:
      return {
        ...state,
        chat: action.payload.chat.reverse(),
        support: action.payload.support,
      };

    case GET_CHAT_FAIL:
      return { ...state, error: action.payload };
    // post chat
    case POST_CHAT_REQUEST:
      return { ...state, loading: false };

    // case POST_CHAT_SUCCESS:
    //   return { ...state, loading: false, chat: [...state.chat, action.payload] };

    case POST_CHAT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADDTO_CHAT_SUCCESS:
      return { ...state, loading: false, chat: [...state.chat, action.payload] };

    // create ticket
    case SEND_TRANSCRIPT_REQUEST:
      return { ...state, loading: true };

    case SEND_TRANSCRIPT_SUCCESS:
      return { ...state, loading: false, sentTranscript: action.payload };

    case SEND_TRANSCRIPT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case "SEEN_MESSAGE":
      return {
        ...state,
        loading: false,
        chat: state.chat.map((element) => ({ ...element, isSeen: true })),
      };

    default:
      return state;
  }
};
